import {observable} from "mobx";
import api from "../Services/Api";

class ProductInfoStore {
    @observable url: string = '';
    @observable loading: boolean = false;
    @observable product?: ProductInfoDto;
    @observable visible: boolean = false;
    async load() {
        this.setLoading(true);
        try {
            const result = await api.post('admin/productInfo', {
                url: this.url
            });
            if (result.success) {
                this.product = result.data;
            }
        }
        finally {
            this.setLoading(false);
        }
    }
    
    private setLoading(loading: boolean) {
        this.loading = loading;
    }
    
    changeUrl(url: string) {
        this.url = url;
    }
    
    show() {
        this.visible = true;
    }
    
    hide() {
        this.visible = false;
    }
}

export type ProductInfoDto = {
    id: string;
    type: string;
    unloads: UnloadDto[];
}

export type UnloadDto = {
    id: string;
    name: string;
    userId: string;
}

const productInfoStore = new ProductInfoStore();
export default productInfoStore;